import { uploadToSeaweedFS } from '@/lib/seaweedfs';

/**
 * voiceStorage — enregistrement durable d'une note vocale dans le stockage
 * du compte.
 *
 * L'audio est rangé sous `users/{userId}/ai-voice/...` (dossier personnel, donc
 * compté dans le quota de stockage de l'utilisateur). On renvoie une URL
 * publique compatible avec `<audio>` : la note vocale reste donc réécoutable
 * même après le rechargement de la page.
 */

/** Garde-fou : une note vocale reste courte (≈30 s), on borne malgré tout. */
const MAX_VOICE_BYTES = 10 * 1024 * 1024;

function extensionFor(mime: string): string {
  const m = (mime || '').toLowerCase();
  if (m.includes('mp4') || m.includes('m4a') || m.includes('aac')) return 'm4a';
  if (m.includes('ogg')) return 'ogg';
  if (m.includes('wav')) return 'wav';
  if (m.includes('mpeg') || m.includes('mp3')) return 'mp3';
  return 'webm';
}

/**
 * Téléverse une note vocale et renvoie son URL publique durable.
 * Le dossier `users/{userId}/` rattache le fichier au compte (quota + gestion).
 */
export async function uploadVoiceNote(blob: Blob, userId: number, mimeType?: string): Promise<string> {
  if (!userId || userId <= 0) {
    throw new Error('Utilisateur non identifié pour enregistrer la note vocale.');
  }
  if (!blob || blob.size === 0) {
    throw new Error('Note vocale vide.');
  }
  if (blob.size > MAX_VOICE_BYTES) {
    throw new Error('La note vocale est trop volumineuse.');
  }
  const type = mimeType || blob.type || 'audio/webm';
  const bytes = new Uint8Array(await blob.arrayBuffer());
  const fileName = `note-vocale.${extensionFor(type)}`;
  return uploadToSeaweedFS(bytes, fileName, type, `users/${userId}/ai-voice`);
}